export function fullPath(e){
  if (e && e.match(/\https\:/)) return e
  return 'https://radiopiterfm.ru/' + e
}
